var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditWhite = function SvgEditWhite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91675 1.74985C10.07 1.59664 10.2518 1.47511 10.452 1.39219C10.6522 1.30928 10.8667 1.2666 11.0834 1.2666C11.3001 1.2666 11.5146 1.30928 11.7148 1.39219C11.915 1.47511 12.0969 1.59664 12.2501 1.74985C12.4033 1.90306 12.5248 2.08494 12.6077 2.28512C12.6907 2.4853 12.7333 2.69985 12.7333 2.91652C12.7333 3.13319 12.6907 3.34774 12.6077 3.54791C12.5248 3.74809 12.4033 3.92998 12.2501 4.08318L4.37508 11.9582L1.16675 12.8332L2.04175 9.62485L9.91675 1.74985Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit-white.e8b2e464.svg";
export { ForwardRef as ReactComponent };